module.exports = __webpack_public_path__ + "img/show_tc_text_1.be0e57ff.png";